import { Card, ErrorFallback } from "materia"
import { useTranslation } from "react-i18next"
import s from "./ProductCategories.module.scss"

export const ProductCategoriesError = ({ error }: { error: unknown }) => {
  const { t } = useTranslation()

  return (
    <Card>
      <div className={s.error}>
        <ErrorFallback
          error={error}
          title={t("error.GENERIC")}
          message={t("error.PRODUCT_CATEGORIES_FETCH_ERROR")}
        />
      </div>
    </Card>
  )
}
